import { ExcludedEndpointInterface } from '../models/excluded-endpoint.model';

export const EXCLUDED_ENDPOINTS: ExcludedEndpointInterface[] = [
  {
    method: 'DELETE',
    pattern: /\/user-leaves\/\d+\/cover(?:\?|$)/,
  },
];
